const setting = {
  os: [
    {
      id: '1',
      name: 'iOS',
    },
    {
      id: '2',
      name: 'Android',
    },
  ],
  zones: [
    {
      id: '0',
      name: 'Residential',
    },
    {
      id: '1',
      name: 'Data Center',
    },
    {
      id: '2',
      name: 'Mobile 3G/4G',
    },
  ],
  countries: [
    {
      code: 'AD',
      code_name: 'AD-Andorra',
    },
    {
      code: 'AE',
      code_name: 'AE-United arab emirates',
    },
    {
      code: 'AF',
      code_name: 'AF-Afghanistan',
    },
    {
      code: 'AG',
      code_name: 'AG-Antigua and barbuda',
    },
    {
      code: 'AI',
      code_name: 'AI-Anguilla',
    },
    {
      code: 'AL',
      code_name: 'AL-Albania',
    },
    {
      code: 'AM',
      code_name: 'AM-Armenia',
    },
    {
      code: 'AO',
      code_name: 'AO-Angola',
    },
    {
      code: 'AQ',
      code_name: 'AQ-Antarctica',
    },
    {
      code: 'AR',
      code_name: 'AR-Argentina',
    },
    {
      code: 'AS',
      code_name: 'AS-American samoa',
    },
    {
      code: 'AT',
      code_name: 'AT-Austria',
    },
    {
      code: 'AU',
      code_name: 'AU-Australia',
    },
    {
      code: 'AW',
      code_name: 'AW-Aruba',
    },
    {
      code: 'AX',
      code_name: 'AX-Åland islands',
    },
    {
      code: 'AZ',
      code_name: 'AZ-Azerbaijan',
    },
    {
      code: 'BA',
      code_name: 'BA-Bosnia and herzegovina',
    },
    {
      code: 'BB',
      code_name: 'BB-Barbados',
    },
    {
      code: 'BD',
      code_name: 'BD-Bangladesh',
    },
    {
      code: 'BE',
      code_name: 'BE-Belgium',
    },
    {
      code: 'BF',
      code_name: 'BF-Burkina faso',
    },
    {
      code: 'BG',
      code_name: 'BG-Bulgaria',
    },
    {
      code: 'BH',
      code_name: 'BH-Bahrain',
    },
    {
      code: 'BI',
      code_name: 'BI-Burundi',
    },
    {
      code: 'BJ',
      code_name: 'BJ-Benin',
    },
    {
      code: 'BL',
      code_name: 'BL-Saint barthélemy',
    },
    {
      code: 'BM',
      code_name: 'BM-Bermuda',
    },
    {
      code: 'BN',
      code_name: 'BN-Brunei darussalam',
    },
    {
      code: 'BO',
      code_name: 'BO-Bolivia, plurinational state of',
    },
    {
      code: 'BQ',
      code_name: 'BQ-Bonaire, sint eustatius and saba',
    },
    {
      code: 'BR',
      code_name: 'BR-Brazil',
    },
    {
      code: 'BS',
      code_name: 'BS-Bahamas',
    },
    {
      code: 'BT',
      code_name: 'BT-Bhutan',
    },
    {
      code: 'BV',
      code_name: 'BV-Bouvet island',
    },
    {
      code: 'BW',
      code_name: 'BW-Botswana',
    },
    {
      code: 'BY',
      code_name: 'BY-Belarus',
    },
    {
      code: 'BZ',
      code_name: 'BZ-Belize',
    },
    {
      code: 'CA',
      code_name: 'CA-Canada',
    },
    {
      code: 'CC',
      code_name: 'CC-Cocos (keeling) islands',
    },
    {
      code: 'CD',
      code_name: 'CD-Congo, the democratic republic of the',
    },
    {
      code: 'CF',
      code_name: 'CF-Central african republic',
    },
    {
      code: 'CG',
      code_name: 'CG-Congo',
    },
    {
      code: 'CH',
      code_name: 'CH-Switzerland',
    },
    {
      code: 'CI',
      code_name: 'CI-Côte d\'ivoire',
    },
    {
      code: 'CK',
      code_name: 'CK-Cook islands',
    },
    {
      code: 'CL',
      code_name: 'CL-Chile',
    },
    {
      code: 'CM',
      code_name: 'CM-Cameroon',
    },
    {
      code: 'CN',
      code_name: 'CN-China(Mainland)',
    },
    {
      code: 'CO',
      code_name: 'CO-Colombia',
    },
    {
      code: 'CR',
      code_name: 'CR-Costa rica',
    },
    {
      code: 'CU',
      code_name: 'CU-Cuba',
    },
    {
      code: 'CV',
      code_name: 'CV-Cape verde',
    },
    {
      code: 'CW',
      code_name: 'CW-Curaçao',
    },
    {
      code: 'CX',
      code_name: 'CX-Christmas island',
    },
    {
      code: 'CY',
      code_name: 'CY-Cyprus',
    },
    {
      code: 'CZ',
      code_name: 'CZ-Czech republic',
    },
    {
      code: 'DE',
      code_name: 'DE-Germany',
    },
    {
      code: 'DJ',
      code_name: 'DJ-Djibouti',
    },
    {
      code: 'DK',
      code_name: 'DK-Denmark',
    },
    {
      code: 'DM',
      code_name: 'DM-Dominica',
    },
    {
      code: 'DO',
      code_name: 'DO-Dominican republic',
    },
    {
      code: 'DZ',
      code_name: 'DZ-Algeria',
    },
    {
      code: 'EC',
      code_name: 'EC-Ecuador',
    },
    {
      code: 'EE',
      code_name: 'EE-Estonia',
    },
    {
      code: 'EG',
      code_name: 'EG-Egypt',
    },
    {
      code: 'EH',
      code_name: 'EH-Western sahara',
    },
    {
      code: 'ER',
      code_name: 'ER-Eritrea',
    },
    {
      code: 'ES',
      code_name: 'ES-Spain',
    },
    {
      code: 'ET',
      code_name: 'ET-Ethiopia',
    },
    {
      code: 'FI',
      code_name: 'FI-Finland',
    },
    {
      code: 'FJ',
      code_name: 'FJ-Fiji',
    },
    {
      code: 'FK',
      code_name: 'FK-Falkland islands (malvinas)',
    },
    {
      code: 'FM',
      code_name: 'FM-Micronesia, federated states of',
    },
    {
      code: 'FO',
      code_name: 'FO-Faroe islands',
    },
    {
      code: 'FR',
      code_name: 'FR-France',
    },
    {
      code: 'GA',
      code_name: 'GA-Gabon',
    },
    {
      code: 'GB',
      code_name: 'GB-United kingdom',
    },
    {
      code: 'GD',
      code_name: 'GD-Grenada',
    },
    {
      code: 'GE',
      code_name: 'GE-Georgia',
    },
    {
      code: 'GF',
      code_name: 'GF-French guiana',
    },
    {
      code: 'GG',
      code_name: 'GG-Guernsey',
    },
    {
      code: 'GH',
      code_name: 'GH-Ghana',
    },
    {
      code: 'GI',
      code_name: 'GI-Gibraltar',
    },
    {
      code: 'GL',
      code_name: 'GL-Greenland',
    },
    {
      code: 'GM',
      code_name: 'GM-Gambia',
    },
    {
      code: 'GN',
      code_name: 'GN-Guinea',
    },
    {
      code: 'GP',
      code_name: 'GP-Guadeloupe',
    },
    {
      code: 'GQ',
      code_name: 'GQ-Equatorial guinea',
    },
    {
      code: 'GR',
      code_name: 'GR-Greece',
    },
    {
      code: 'GS',
      code_name: 'GS-South georgia and the south sandwich islands',
    },
    {
      code: 'GT',
      code_name: 'GT-Guatemala',
    },
    {
      code: 'GU',
      code_name: 'GU-Guam',
    },
    {
      code: 'GW',
      code_name: 'GW-Guinea-bissau',
    },
    {
      code: 'GY',
      code_name: 'GY-Guyana',
    },
    {
      code: 'HK',
      code_name: 'HK-Hong kong(China)',
    },
    {
      code: 'HM',
      code_name: 'HM-Heard island and mcdonald islands',
    },
    {
      code: 'HN',
      code_name: 'HN-Honduras',
    },
    {
      code: 'HR',
      code_name: 'HR-Croatia',
    },
    {
      code: 'HT',
      code_name: 'HT-Haiti',
    },
    {
      code: 'HU',
      code_name: 'HU-Hungary',
    },
    {
      code: 'ID',
      code_name: 'ID-Indonesia',
    },
    {
      code: 'IE',
      code_name: 'IE-Ireland',
    },
    {
      code: 'IL',
      code_name: 'IL-Israel',
    },
    {
      code: 'IM',
      code_name: 'IM-Isle of man',
    },
    {
      code: 'IN',
      code_name: 'IN-India',
    },
    {
      code: 'IO',
      code_name: 'IO-British indian ocean territory',
    },
    {
      code: 'IQ',
      code_name: 'IQ-Iraq',
    },
    {
      code: 'IR',
      code_name: 'IR-Iran, islamic republic of',
    },
    {
      code: 'IS',
      code_name: 'IS-Iceland',
    },
    {
      code: 'IT',
      code_name: 'IT-Italy',
    },
    {
      code: 'JE',
      code_name: 'JE-Jersey',
    },
    {
      code: 'JM',
      code_name: 'JM-Jamaica',
    },
    {
      code: 'JO',
      code_name: 'JO-Jordan',
    },
    {
      code: 'JP',
      code_name: 'JP-Japan',
    },
    {
      code: 'KE',
      code_name: 'KE-Kenya',
    },
    {
      code: 'KG',
      code_name: 'KG-Kyrgyzstan',
    },
    {
      code: 'KH',
      code_name: 'KH-Cambodia',
    },
    {
      code: 'KI',
      code_name: 'KI-Kiribati',
    },
    {
      code: 'KM',
      code_name: 'KM-Comoros',
    },
    {
      code: 'KN',
      code_name: 'KN-Saint kitts and nevis',
    },
    {
      code: 'KP',
      code_name: 'KP-Korea, democratic people\'s republic of',
    },
    {
      code: 'KR',
      code_name: 'KR-Korea, republic of',
    },
    {
      code: 'KW',
      code_name: 'KW-Kuwait',
    },
    {
      code: 'KY',
      code_name: 'KY-Cayman islands',
    },
    {
      code: 'KZ',
      code_name: 'KZ-Kazakhstan',
    },
    {
      code: 'LA',
      code_name: 'LA-Lao people\'s democratic republic',
    },
    {
      code: 'LB',
      code_name: 'LB-Lebanon',
    },
    {
      code: 'LC',
      code_name: 'LC-Saint lucia',
    },
    {
      code: 'LI',
      code_name: 'LI-Liechtenstein',
    },
    {
      code: 'LK',
      code_name: 'LK-Sri lanka',
    },
    {
      code: 'LR',
      code_name: 'LR-Liberia',
    },
    {
      code: 'LS',
      code_name: 'LS-Lesotho',
    },
    {
      code: 'LT',
      code_name: 'LT-Lithuania',
    },
    {
      code: 'LU',
      code_name: 'LU-Luxembourg',
    },
    {
      code: 'LV',
      code_name: 'LV-Latvia',
    },
    {
      code: 'LY',
      code_name: 'LY-Libya',
    },
    {
      code: 'MA',
      code_name: 'MA-Morocco',
    },
    {
      code: 'MC',
      code_name: 'MC-Monaco',
    },
    {
      code: 'MD',
      code_name: 'MD-Moldova, republic of',
    },
    {
      code: 'ME',
      code_name: 'ME-Montenegro',
    },
    {
      code: 'MF',
      code_name: 'MF-Saint martin (french part)',
    },
    {
      code: 'MG',
      code_name: 'MG-Madagascar',
    },
    {
      code: 'MH',
      code_name: 'MH-Marshall islands',
    },
    {
      code: 'MK',
      code_name: 'MK-Macedonia, the former yugoslav republic of',
    },
    {
      code: 'ML',
      code_name: 'ML-Mali',
    },
    {
      code: 'MM',
      code_name: 'MM-Myanmar',
    },
    {
      code: 'MN',
      code_name: 'MN-Mongolia',
    },
    {
      code: 'MO',
      code_name: 'MO-Macao(China)',
    },
    {
      code: 'MP',
      code_name: 'MP-Northern mariana islands',
    },
    {
      code: 'MQ',
      code_name: 'MQ-Martinique',
    },
    {
      code: 'MR',
      code_name: 'MR-Mauritania',
    },
    {
      code: 'MS',
      code_name: 'MS-Montserrat',
    },
    {
      code: 'MT',
      code_name: 'MT-Malta',
    },
    {
      code: 'MU',
      code_name: 'MU-Mauritius',
    },
    {
      code: 'MV',
      code_name: 'MV-Maldives',
    },
    {
      code: 'MW',
      code_name: 'MW-Malawi',
    },
    {
      code: 'MX',
      code_name: 'MX-Mexico',
    },
    {
      code: 'MY',
      code_name: 'MY-Malaysia',
    },
    {
      code: 'MZ',
      code_name: 'MZ-Mozambique',
    },
    {
      code: 'NA',
      code_name: 'NA-Namibia',
    },
    {
      code: 'NC',
      code_name: 'NC-New caledonia',
    },
    {
      code: 'NE',
      code_name: 'NE-Niger',
    },
    {
      code: 'NF',
      code_name: 'NF-Norfolk island',
    },
    {
      code: 'NG',
      code_name: 'NG-Nigeria',
    },
    {
      code: 'NI',
      code_name: 'NI-Nicaragua',
    },
    {
      code: 'NL',
      code_name: 'NL-Netherlands',
    },
    {
      code: 'NO',
      code_name: 'NO-Norway',
    },
    {
      code: 'NP',
      code_name: 'NP-Nepal',
    },
    {
      code: 'NR',
      code_name: 'NR-Nauru',
    },
    {
      code: 'NU',
      code_name: 'NU-Niue',
    },
    {
      code: 'NZ',
      code_name: 'NZ-New zealand',
    },
    {
      code: 'OM',
      code_name: 'OM-Oman',
    },
    {
      code: 'PA',
      code_name: 'PA-Panama',
    },
    {
      code: 'PE',
      code_name: 'PE-Peru',
    },
    {
      code: 'PF',
      code_name: 'PF-French polynesia',
    },
    {
      code: 'PG',
      code_name: 'PG-Papua new guinea',
    },
    {
      code: 'PH',
      code_name: 'PH-Philippines',
    },
    {
      code: 'PK',
      code_name: 'PK-Pakistan',
    },
    {
      code: 'PL',
      code_name: 'PL-Poland',
    },
    {
      code: 'PM',
      code_name: 'PM-Saint pierre and miquelon',
    },
    {
      code: 'PN',
      code_name: 'PN-Pitcairn',
    },
    {
      code: 'PR',
      code_name: 'PR-Puerto rico',
    },
    {
      code: 'PS',
      code_name: 'PS-Palestine, state of',
    },
    {
      code: 'PT',
      code_name: 'PT-Portugal',
    },
    {
      code: 'PW',
      code_name: 'PW-Palau',
    },
    {
      code: 'PY',
      code_name: 'PY-Paraguay',
    },
    {
      code: 'QA',
      code_name: 'QA-Qatar',
    },
    {
      code: 'RE',
      code_name: 'RE-Réunion',
    },
    {
      code: 'RO',
      code_name: 'RO-Romania',
    },
    {
      code: 'RS',
      code_name: 'RS-Serbia',
    },
    {
      code: 'RU',
      code_name: 'RU-Russian federation',
    },
    {
      code: 'RW',
      code_name: 'RW-Rwanda',
    },
    {
      code: 'SA',
      code_name: 'SA-Saudi arabia',
    },
    {
      code: 'SB',
      code_name: 'SB-Solomon islands',
    },
    {
      code: 'SC',
      code_name: 'SC-Seychelles',
    },
    {
      code: 'SD',
      code_name: 'SD-Sudan',
    },
    {
      code: 'SE',
      code_name: 'SE-Sweden',
    },
    {
      code: 'SG',
      code_name: 'SG-Singapore',
    },
    {
      code: 'SH',
      code_name: 'SH-Saint helena, ascension and tristan da cunha',
    },
    {
      code: 'SI',
      code_name: 'SI-Slovenia',
    },
    {
      code: 'SJ',
      code_name: 'SJ-Svalbard and jan mayen',
    },
    {
      code: 'SK',
      code_name: 'SK-Slovakia',
    },
    {
      code: 'SL',
      code_name: 'SL-Sierra leone',
    },
    {
      code: 'SM',
      code_name: 'SM-San marino',
    },
    {
      code: 'SN',
      code_name: 'SN-Senegal',
    },
    {
      code: 'SO',
      code_name: 'SO-Somalia',
    },
    {
      code: 'SR',
      code_name: 'SR-Suriname',
    },
    {
      code: 'SS',
      code_name: 'SS-South sudan',
    },
    {
      code: 'ST',
      code_name: 'ST-Sao tome and principe',
    },
    {
      code: 'SV',
      code_name: 'SV-El salvador',
    },
    {
      code: 'SX',
      code_name: 'SX-Sint maarten (dutch part)',
    },
    {
      code: 'SY',
      code_name: 'SY-Syrian arab republic',
    },
    {
      code: 'SZ',
      code_name: 'SZ-Swaziland',
    },
    {
      code: 'TC',
      code_name: 'TC-Turks and caicos islands',
    },
    {
      code: 'TD',
      code_name: 'TD-Chad',
    },
    {
      code: 'TF',
      code_name: 'TF-French southern territories',
    },
    {
      code: 'TG',
      code_name: 'TG-Togo',
    },
    {
      code: 'TH',
      code_name: 'TH-Thailand',
    },
    {
      code: 'TJ',
      code_name: 'TJ-Tajikistan',
    },
    {
      code: 'TK',
      code_name: 'TK-Tokelau',
    },
    {
      code: 'TL',
      code_name: 'TL-Timor-leste',
    },
    {
      code: 'TM',
      code_name: 'TM-Turkmenistan',
    },
    {
      code: 'TN',
      code_name: 'TN-Tunisia',
    },
    {
      code: 'TO',
      code_name: 'TO-Tonga',
    },
    {
      code: 'TR',
      code_name: 'TR-Turkey',
    },
    {
      code: 'TT',
      code_name: 'TT-Trinidad and tobago',
    },
    {
      code: 'TV',
      code_name: 'TV-Tuvalu',
    },
    {
      code: 'TW',
      code_name: 'TW-Taiwan(China)',
    },
    {
      code: 'TZ',
      code_name: 'TZ-Tanzania, united republic of',
    },
    {
      code: 'UA',
      code_name: 'UA-Ukraine',
    },
    {
      code: 'UG',
      code_name: 'UG-Uganda',
    },
    {
      code: 'UM',
      code_name: 'UM-United states minor outlying islands',
    },
    {
      code: 'US',
      code_name: 'US-United states',
    },
    {
      code: 'UY',
      code_name: 'UY-Uruguay',
    },
    {
      code: 'UZ',
      code_name: 'UZ-Uzbekistan',
    },
    {
      code: 'VA',
      code_name: 'VA-Holy see (vatican city state)',
    },
    {
      code: 'VC',
      code_name: 'VC-Saint vincent and the grenadines',
    },
    {
      code: 'VE',
      code_name: 'VE-Venezuela, bolivarian republic of',
    },
    {
      code: 'VG',
      code_name: 'VG-Virgin islands, british',
    },
    {
      code: 'VI',
      code_name: 'VI-Virgin islands, u.s.',
    },
    {
      code: 'VN',
      code_name: 'VN-Viet nam',
    },
    {
      code: 'VU',
      code_name: 'VU-Vanuatu',
    },
    {
      code: 'WF',
      code_name: 'WF-Wallis and futuna',
    },
    {
      code: 'WS',
      code_name: 'WS-Samoa',
    },
    {
      code: 'YE',
      code_name: 'YE-Yemen',
    },
    {
      code: 'YT',
      code_name: 'YT-Mayotte',
    },
    {
      code: 'ZA',
      code_name: 'ZA-South africa',
    },
    {
      code: 'ZM',
      code_name: 'ZM-Zambia',
    },
    {
      code: 'ZW',
      code_name: 'ZW-Zimbabwe',
    },
  ],

  carriers: [
    {
      code: '',
      carrier: 'Default Carrier',
    },
    {
      code: 'telefonica',
      carrier: 'Telefonica',
    },
    {
      code: 'docomo',
      carrier: 'Docomo',
    },
    {
      code: 'optus',
      carrier: 'Optus',
    },
    {
      code: 'singtel',
      carrier: 'Singtel',
    },
    {
      code: 'cellc',
      carrier: 'Cellc',
    },
    {
      code: 'cox',
      carrier: 'Cox',
    },
    {
      code: 'bouygues',
      carrier: 'Bouygues',
    },
    {
      code: 'umobile',
      carrier: 'Umobile',
    },
    {
      code: 'proximus',
      carrier: 'Proximus',
    },
    {
      code: 'vimpelcom',
      carrier: 'Vimpelcom',
    },
    {
      code: 'cableone',
      carrier: 'Cableone',
    },
    {
      code: 'qwest',
      carrier: 'Qwest',
    },
    {
      code: 'comcast',
      carrier: 'Comcast',
    },
    {
      code: 'windit',
      carrier: 'Windit',
    },
    {
      code: 'tim',
      carrier: 'Tim',
    },
    {
      code: 'telenormyanmar',
      carrier: 'Telenormyanmar',
    },
    {
      code: 'tmobile',
      carrier: 'Tmobile',
    },
    {
      code: 'digicel',
      carrier: 'Digicel',
    },
    {
      code: 'dt',
      carrier: 'Dt',
    },
    {
      code: 'zain',
      carrier: 'Zain',
    },
    {
      code: 'asiacell',
      carrier: 'Asiacell',
    },
    {
      code: 'sprint',
      carrier: 'Sprint',
    },
    {
      code: 'kyivstar',
      carrier: 'Kyivstar',
    },
    {
      code: 'sfr',
      carrier: 'Sfr',
    },
    {
      code: 'robi',
      carrier: 'Robi',
    },
    {
      code: 'telstra',
      carrier: 'Telstra',
    },
    {
      code: 'claro',
      carrier: 'Claro',
    },
    {
      code: 'mtn',
      carrier: 'Mtn',
    },
    {
      code: 'mtnza',
      carrier: 'Mtnza',
    },
    {
      code: 'ooredoo',
      carrier: 'Ooredoo',
    },
    {
      code: 'kcelljsc',
      carrier: 'Kcelljsc',
    },
    {
      code: 'reliance_jio',
      carrier: 'Reliance_jio',
    },
    {
      code: 'chinamobile',
      carrier: 'Chinamobile',
    },
    {
      code: 'aircel',
      carrier: 'Aircel',
    },
    {
      code: 'tele2',
      carrier: 'Tele2',
    },
    {
      code: 'free',
      carrier: 'Free',
    },
    {
      code: 'vivo',
      carrier: 'Vivo',
    },
    {
      code: 'celcom',
      carrier: 'Celcom',
    },
    {
      code: 'etisalat',
      carrier: 'Etisalat',
    },
    {
      code: 'o2',
      carrier: 'O2',
    },
    {
      code: 'mts',
      carrier: 'Mts',
    },
    {
      code: 'digi',
      carrier: 'Digi',
    },
    {
      code: 'mobitel',
      carrier: 'Mobitel',
    },
    {
      code: 'a1',
      carrier: 'A1',
    },
    {
      code: 'vodafone',
      carrier: 'Vodafone',
    },
    {
      code: 'orange',
      carrier: 'Orange',
    },
    {
      code: 'vivabo',
      carrier: 'Vivabo',
    },
    {
      code: 'airtel',
      carrier: 'Airtel',
    },
    {
      code: 'meo',
      carrier: 'Meo',
    },
    {
      code: 'swisscom',
      carrier: 'Swisscom',
    },
    {
      code: 'idea',
      carrier: 'Idea',
    },
    {
      code: 'dtac',
      carrier: 'Dtac',
    },
    {
      code: 'verizon',
      carrier: 'Verizon',
    },
    {
      code: 'tigo',
      carrier: 'Tigo',
    },
    {
      code: 'drei',
      carrier: 'Drei',
    },
    {
      code: 'vodacomza',
      carrier: 'Vodacomza',
    },
    {
      code: 'att',
      carrier: 'Att',
    },
    {
      code: 'megafon',
      carrier: 'Megafon',
    },
  ],
  default_carriers: [
    {
      carrier: 'Default Carrier',
      code: '',
    },
  ],
}

export default setting
